import { memo } from "react";

/**
 * Icon-first flip tile for PaceHRM shell rail / secondary bar.
 * @param {'y'|'x'} axis - y = right→left (ESS rail), x = bottom→top (admin secondary)
 * @param {'line'|'soft'} variant - line = Lucide outline (admin); soft = clay PNG (ESS)
 * @param {string|number|null} badge - optional count badge (top-right)
 */
function ShellFlipTile({
  icon: Icon,
  label,
  axis = "y",
  variant = "soft",
  active = false,
  flipped = false,
  disabled = false,
  title,
  onClick,
  className = "",
  badge = null,
}) {
  const open = !!flipped;
  const isY = axis === "y";
  const tip = String(title || label || "").trim();
  const badgeText =
    badge == null || badge === "" || Number(badge) <= 0
      ? null
      : Number(badge) > 10
        ? "10.."
        : String(badge);

  const ariaLabel = badgeText
    ? `${tip || label}, ${badgeText} pending`
    : tip || label;

  return (
    <button
      type="button"
      disabled={disabled}
      title={tip || undefined}
      aria-label={ariaLabel}
      aria-pressed={active || open}
      onClick={onClick}
      className={`pace-shell-flip-tile relative ${
        active ? "is-active" : ""
      } ${open ? "is-open" : ""} ${
        isY ? "axis-y" : "axis-x"
      } ${variant === "line" ? "variant-line" : "variant-soft"} ${
        disabled ? "is-disabled" : ""
      } ${className}`.trim()}
    >
      <span className="pace-shell-flip-inner" aria-hidden="true">
        <span className="pace-shell-flip-face pace-shell-flip-icon">
          {Icon ? (
            variant === "line" ? (
              <Icon
                size={24}
                strokeWidth={1.75}
                fill="currentColor"
                className={`pace-shell-nav-icon pace-shell-line-icon${
                  active ? " is-filled" : ""
                }`}
                aria-hidden
              />
            ) : (
              <Icon
                size={28}
                className="pace-shell-nav-icon pace-soft3d-icon"
                aria-hidden
              />
            )
          ) : null}
        </span>
        <span className="pace-shell-flip-face pace-shell-flip-name">
          <span className="pace-shell-flip-label">{label}</span>
        </span>
      </span>
      {badgeText ? (
        <span
          className="pointer-events-none absolute right-[2px] top-[2px] z-[2] flex h-[15px] min-w-[15px] items-center justify-center rounded-full border border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-bg))] px-[3px] text-[9px] font-bold leading-none text-[hsl(var(--ds-primary))]"
          aria-hidden
        >
          {badgeText}
        </span>
      ) : null}
    </button>
  );
}

export default memo(ShellFlipTile);
